import { render, staticRenderFns } from "./ConnectIcons.vue?vue&type=template&id=2480e081"
import script from "./ConnectIcons.vue?vue&type=script&lang=js"
export * from "./ConnectIcons.vue?vue&type=script&lang=js"
import style0 from "./ConnectIcons.vue?vue&type=style&index=0&id=2480e081&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports